import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { financialConditionGenerationStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/styles.ts';

interface IFinancialConditionSectionProps {
  title: string;
  description?: React.ReactNode;
  tooltip?: React.ReactNode;
  tooltipLabel?: string;
  children: React.ReactNode;
}

export const FinancialConditionSection: React.FC<IFinancialConditionSectionProps> = ({
  title,
  description,
  tooltip,
  tooltipLabel = `Пояснення до секції «${title}»`,
  children,
}) => (
  <Box component="section" sx={financialConditionGenerationStyles.sectionContainer}>
    <Box sx={financialConditionGenerationStyles.sectionHeader}>
      <Box sx={{ minWidth: 0 }}>
        <Typography component="h3" sx={financialConditionGenerationStyles.sectionHeaderTitle}>
          {title}
          {tooltip && (
            <Tooltip title={tooltip} arrow slotProps={{ tooltip: { sx: { maxWidth: 520 } } }}>
              <IconButton
                aria-label={tooltipLabel}
                size="small"
                sx={{ ml: 0.5, p: 0.25, verticalAlign: 'text-bottom' }}
              >
                <InfoOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.4 }}>
            {description}
          </Typography>
        )}
      </Box>
    </Box>
    <Box sx={financialConditionGenerationStyles.sectionContent}>{children}</Box>
  </Box>
);
